<template>
  <div>
    <CantTransactions v-can="'Cantidad Trasacciones'" ref="CantTransactions" />
    <processed-docs ref="ProcessedDocs" />
    <pending-docs ref="PendingDocs" />
    <config-billing-date ref="ConfigBillingDate" />
    <config-trade-name ref="ConfigTradeName" />
    <config-contingency-auto ref="ConfigContingencyAuto" />
    <config-activar-dee ref="ConfigActivarDEE" />
    <config-address-optional ref="ConfigAddressOptional" />
    <config-email-optional ref="ConfigEmailOptional" />
    <!-- <config-alerts-folios ref="ConfigAlertsFolios" />
    <config-alerts-certificate ref="ConfigAlertsCertificate" /> -->
  </div>
</template>

<script>

  export default {
    components: {
      ProcessedDocs: () => import('./components/ProcessedDocs'),
      PendingDocs: () => import('./components/PendingDocs'),
      ConfigBillingDate: () => import('./components/BillingDateConfigs'),
      ConfigTradeName: () => import('./components/TradeNameConfigs'),
      ConfigContingencyAuto: () => import('./components/ContingencyAutoConfigs'),
      ConfigActivarDee: () => import('./components/ActivarDEEConfigs'),
      ConfigAddressOptional: () => import('./components/AddressOptional'),
      ConfigEmailOptional: () => import('./components/EmailOptional'),
      ConfigAlertsFolios: () => import('./components/FoliosConfigs'),
      ConfigAlertsCertificate: () => import('./components/CertificateConfigs'),
      CantTransactions: () => import('./components/CantTransactions'),
    },
  }
</script>
